import React, { useRef } from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const services = [
  {
    label: "Solar Preventive Maintenance",
    path: "/solar-preventive-maintaince",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471096/full-service_l7ppid.png",
  },
  {
    label: "PV Installation",
    path: "/pv-installation",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471096/pv-installation_qinoh9.png",
  },
  {
    label: "PV Bird Proofing",
    path: "/bird-proofing",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471096/bird-roofing_ozqlpa.png",
  },
  {
    label: "Handling Manufacturing Warranty",
    path: "/warranty",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471095/handling-warranty_ldy68k.png",
  },
  {
    label: "Health Report",
    path: "/health-report",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471095/plant-report_vk9r0i.png",
  },
  {
    label: "System Repair",
    path: "/system-repair",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471095/system-repair_mvsud1.png",
  },
  {
    label: "Consultation",
    path: "/consultation",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749471095/consultation_rnucog.png",
  },
  {
    label: "PV Protection Coatings",
    path: "/pv-protection-coatings",
    img: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1749990820/pv-coating_tblg4l.png",
  },
];

const ServicesButtonList = () => {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <section className="py-16 px-6 sm:px-10 md:px-16 lg:px-24">
      <h1
          className="text-6xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl 2xl:text-8xl font-bold text-black text-center mb-10"
        >
        Our Services
      </h1>

      {/* Cards Scrollable Row / Grid */}
      <div
        ref={scrollRef}
        className="flex md:grid md:grid-cols-3 lg:grid-cols-4 gap-6 overflow-x-auto md:overflow-visible scroll-smooth hide-scrollbar"
      >
        {services.map((service, index) => (
          <Link
            key={index}
            to={service.path}
            className="card-gradient-hover min-w-[260px] md:min-w-0 flex-shrink-0 md:flex-shrink bg-white rounded-3xl p-6 space-y-4 transition-all duration-300 hover:text-black"
          >
            <div className="text-neutral-900 font-semibold text-xl text-center leading-snug">
              {service.label}
            </div>

            <img
              src={service.img}
              alt={service.label}
              className="h-24 w-auto object-contain mx-auto"
            />

            <div className="text-blue-600 font-medium text-center hover:underline transition">
              Learn More &gt;
            </div>
          </Link>
        ))}
      </div>

      <div className="flex justify-center mt-8 gap-4 md:hidden">
        <button
          onClick={scrollLeft}
          className="w-12 h-12 flex items-center justify-center border border-black rounded-full shadow hover:shadow-md transition"
          aria-label="Scroll Left"
        >
          <FontAwesomeIcon icon={faChevronLeft} className="text-black w-5 h-5" />
        </button>
        <button
          onClick={scrollRight}
          className="w-12 h-12 flex items-center justify-center border border-black rounded-full shadow hover:shadow-md transition"
          aria-label="Scroll Right"
        >
          <FontAwesomeIcon icon={faChevronRight} className="text-black w-5 h-5" />
        </button>
      </div>

    </section>
  );
};

export default ServicesButtonList;